export const ETollList = [
  { sku: "U_ETOLL12" },
  { sku: "U_ETOLL1" },
  { sku: "U_ETOLL24" },
  { sku: "U_ETOLL36" },
  { sku: "U_GPS12" },
  { sku: "U_GPS24" },
  { sku: "U_GPS36" },
  { sku: "U_GPS1" },
  { sku: "U_ETOLLGPS12" },
  { sku: "U_ETOLLGPS24" },
  { sku: "U_ETOLLGPS36" },
  { sku: "U_GW12" },
  { sku: "U_GW24" },
  { sku: "U_GW36" },
  { sku: "U_ETOLLSENT1" },
  { sku: "U_ETOLLSENT12" },
  { sku: "U_R2S12" },
];
